import { render } from "./PrimitiveCircle.vue?vue&type=template&id=3f75eeef"
import script from "./PrimitiveCircle.vue?vue&type=script&lang=js"
export * from "./PrimitiveCircle.vue?vue&type=script&lang=js"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__